var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4C89FE",
  d: "M21.15 3.118 3.434 10.45c-1.21.52-1.202 1.245-.222 1.567l4.549 1.523 10.523-7.125c.498-.325.953-.15.579.205l-8.526 8.258h-.002l.001.001-.313 5.031c.46 0 .662-.226.92-.493l2.21-2.305 4.595 3.642c.847.501 1.456.244 1.666-.841l3.017-15.257c.309-1.329-.473-1.93-1.281-1.538"
})));
export { SvgTelegram as ReactComponent };